import { useEffect } from 'react';


const useScrollToTop = () => {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, []);

};

export default useScrollToTop;
